import ListSelectControl from "./ListSelectControl";
import { STYLE_HOTEL_INPUT } from "../constants";

const INPUT_TYPES = { text: "text", number: "number", datetime: "datetime-local" };

function ListTextControl({ field, value, placeholder, onInput }) {
  if (field.type === "textarea") {
    return (
      <textarea
        rows={3}
        value={value}
        placeholder={placeholder}
        onChange={onInput}
        className={STYLE_HOTEL_INPUT}
      />
    );
  }
  if (field.type === "select") {
    return <ListSelectControl field={field} value={value} onInput={onInput} />;
  }
  return (
    <input
      type={INPUT_TYPES[field.type]}
      value={value}
      placeholder={placeholder}
      onChange={onInput}
      className={STYLE_HOTEL_INPUT}
    />
  );
}

export default ListTextControl;
